import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";

class CashRegisterService {
  getAllCaisseByManager(idUser) {
    return api.get(
      UtilsUrl.CashRegisterPosURL() + "/getAllCaisseByManager/" + idUser
    );
  }
  updateJournalDeCaisse(idUser, data) {
    return api.put(
      UtilsUrl.CashRegisterPosURL() + "/updateJournalCaisseByRef/" + idUser, data
    );
  }

    addNewJournalCaisse(idUser, data) {
    return api.put(
      UtilsUrl.CashRegisterPosURL() + "/addNewJournalCaisse/" + idUser, data
    );
  }
}
export default new CashRegisterService();
